/* ==================================================================
   SERVICIO DE CATÁLOGO (FASE 1 — demo)
   ------------------------------------------------------------------
   Hoy devuelve el catálogo fictivo de `src/data/products.js`.
   En la fase 2, sustituir SOLO este archivo por la Shopify
   Storefront API (oficial) manteniendo la misma interfaz:
   getProducts() y getProduct(handle). Ningún componente cambiará.
================================================================== */
import { products } from "@/data/products";

export const getProducts = () => products;

export const getProduct = (handle) =>
    products.find((p) => p.handle === handle) || null;
